import React, { Component } from "react";
import { Avatar, Popover, Modal } from "antd";
import { connect } from "react-redux";
import { apiAuth } from "../../api/api-auth";
import {
  CaretDownOutlined,
  MenuOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { clearAuth } from "../../common/actions/actions-auth";
import { ChangePassword } from "../../routes/guest/login/components/modal/change-password";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openLogoutModal: false,
    };
  }

  logout = () => {
    this.setState({
      openLogoutModal: true,
    });
    // const { dispatch, history } = this.props;
    // const check = window.confirm('Bạn có chắc chắn đăng xuất không?');
    // if (check){
    //   try {
    //     const result = await apiAuth.logout();
    //     if (result.status === 'success') {
    //       dispatch(clearAuth());
    //       history.push('/login')
    //     } else {
    //       alert(result.data.message);
    //     }
    //   } catch (error) {

    //   }
    // }
  };

  handleOk = async () => {
    const { dispatch, history } = this.props;
    const result = await apiAuth.logout();
    if (result.status === "success") {
      dispatch(clearAuth());
      history.push("/login");
    } else {
      alert(result.data.message);
    }
  };

  handleCancel = () => {
    this.setState({
      openLogoutModal: false,
    });
  };

  content = () => (
    <div className="tooltip">
      <div
        onClick={() =>
          this.changePassWord.visiableModal(true, this.props.auth.username)
        }
        className="tooltip-item"
      >
        <span style={{ fontSize: "0.9em" }}>Đổi mật khẩu</span>
      </div>
      <div
        style={{ paddingTop: 10 }}
        onClick={this.logout}
        className="tooltip-item"
      >
        <span style={{ fontSize: "0.9em" }}>
          <LogoutOutlined /> <span style={{ marginRight: 10 }}>Đăng xuất</span>
        </span>
      </div>
    </div>
  );

  render() {
    const { auth } = this.props;
    const { openLogoutModal } = this.state;
    return (
      <div className="header box-shadow">
        <MenuOutlined onClick={this.props.onCollapse} className="left-icon" />
        <div className="logo">
          <img
            alt=""
            width={100}
            src={require("../../assets/icons/AVIS_logo.svg")}
          />
          <MenuOutlined
            onClick={this.props.onCollapse}
            className="right-icon"
          />
        </div>
        <div className="user-info">
          <Avatar
            size={35}
            style={{ color: "#e33b44", backgroundColor: "#fff" }}
          >
            {auth && auth.name ? auth.name.charAt(0) : ""}
          </Avatar>
          <div className="username">{auth ? auth.name : ""}</div>
          <Popover
            placement="bottomRight"
            content={this.content()}
            trigger="click"
          >
            <CaretDownOutlined />
          </Popover>
        </div>
        <ChangePassword ref={(ref) => (this.changePassWord = ref)} />
        <Modal
          title="Đăng xuất"
          className="logout-modal"
          visible={openLogoutModal}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText={"Có"}
          cancelText={"Không"}
          closable={false}
        >
          <p style={{ textAlign: "center" }}>
            Bạn có chắc muốn đăng xuất khỏi hệ thống không?
          </p>
        </Modal>
      </div>
    );
  }
}

export default connect((state) => ({ auth: state.auth }))(Header);
